module.exports = __webpack_public_path__ + "img/blog-details.f0c3abd3.webp";